import React, { useContext } from "react";
import "./ProjectDetails.css";
import { ProjectContext } from "../context/ProjectContext";

const ImpactProgress = () => {
  const { projectDetails, loadingProject } = useContext(ProjectContext);

  if (loadingProject || !projectDetails) {
    return <div>Loading impact and progress...</div>;
  }

  /* ===== Safe Numbers ===== */
  const approved = Number(projectDetails?.approved_amount || 0);
  const utilized = Number(projectDetails?.utilized_amount || 0);

  const progressPercent =
    approved > 0 ? Math.round((utilized / approved) * 100) : 0;

  /* ===== Safe Achievement Texts ===== */
  const achievements = projectDetails?.achievement_texts
    ? projectDetails.achievement_texts.split(" | ")
    : [];

  /* ===== Safe Achievement Counts ===== */
  const achievementCounts = projectDetails?.achievement_counts
    ? projectDetails.achievement_counts
        .split(" | ")
        .map((item) => {
          const parts = item.split(":");

          return {
            label: parts[0] || "Achievement",
            value: parts[1] || 0,
          };
        })
    : [];

  return (
    <div className="card csr-card shadow-0 mt-4">
      {/* Header */}
      <div className="csr-card-header">
        <div className="csr-icon yellow">
          <i className="fa-solid fa-arrow-trend-up"></i>
        </div>

        <h5 className="mb-0">Impact & Progress</h5>
      </div>

      {/* Progress */}
      <div className="progress-header">
        <span className="progress-label">Overall Progress</span>

        <span className="progress-percent">
          {progressPercent}%
        </span>
      </div>

      <div className="custom-progress">
        <div
          className="custom-progress-bar"
          style={{ width: `${progressPercent}%` }}
        ></div>
      </div>

      {/* Stats */}
      <div className="row g-3 mt-3">
        {/* Beneficiaries */}
        {/* <div className="col-md-6 col-12 shadow-0">
          <div className="impact-box">
            <span className="impact-label">
              Total Beneficiaries
            </span>

            <div className="impact-value">
              {projectDetails?.total_beneficiaries || 0}
            </div>
          </div>
        </div> */}

        {/* Achievement Counts */}
        {achievementCounts.length > 0 &&
          achievementCounts.map((item, index) => (
            <div
              className="col-md-6 col-12 shadow-0"
              key={index}
            >
              <div className="impact-box">
                <span className="impact-label">
                  {item.label}
                </span>

                <div className="impact-value">
                  {item.value}
                </div>
              </div>
            </div>
          ))}
      </div>

      {/* Outcomes */}
      {/* <div className="mt-4">
        <h6 className="csr-subtitle">
          Key Outcomes Achieved
        </h6>

        {achievements.length > 0 ? (
          <ul className="impact-outcomes">
            {achievements.map((item, i) => (
              <li key={i}>
                <i className="fa-solid fa-check-circle"></i>

                <span>{item}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-muted">
            No outcomes available
          </p>
        )}
      </div> */}
    </div>
  );
};

export default ImpactProgress;